import { motion } from 'framer-motion';
import clsx from 'clsx';

const variants = {
  hidden: {
    opacity: 0,
    y: 20,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      delay: 0.5,
      stiffness: 100,
    },
  },
};

export interface LotteryAnimatedCardProps
  extends React.ComponentProps<typeof motion.div> {}

export const LotteryAnimatedCard: React.FC<LotteryAnimatedCardProps> = (
  props,
) => {
  const { children, className, ...rest } = props;

  return (
    <motion.div
      initial="hidden"
      animate="visible"
      variants={variants}
      style={{
        borderImageSlice: 1,
        backdropFilter: 'blur(64px)',
        boxShadow: '0px 0px 12px 0px #FFFFFFA3',
      }}
      className={clsx(
        'max-w-lg overflow-hidden rounded-2xl border border-white/15 bg-white/15 px-8 py-10 backdrop-blur-lg md:px-8',
        className,
      )}
      {...rest}
    >
      {children}
    </motion.div>
  );
};
